import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { Stepper, Step, Typography, StepConnector } from '@material-ui/core';

const contentStyles = theme => ({
  stepPadding: {
    paddingLeft: 0,
  },
  lineHorizontal: {
    border: 'solid 0.5px rgba(151, 151, 151, 0.3)',
  },
});

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, value } = this.props;
    return (
      <div>
        <Stepper
          className={'noPadding'}
          connector={
            <StepConnector
              classes={{
                lineHorizontal: classes.lineHorizontal,
              }}
            />
          }
        >
          <Step active className={classes.stepPadding}>
            <Typography variant="body2" color="textSecondary">
              {value}
            </Typography>
          </Step>
          <Step active>
            <Typography variant="body2" color="textSecondary" />
          </Step>
        </Stepper>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
};

Header = compose(withStyles(contentStyles, { withTheme: true }))(Header);

export default Header;
